import IntlErrorBoundary from '_common/components/IntlErrorBoundary/IntlErrorBoundary';
import SectionHeadingContent, { SectionHeadingProps } from './SectionHeadingContent';

const SectionHeading = (props: SectionHeadingProps) => {
  return (
    <IntlErrorBoundary
      fallbackType="sectionHeading"
      mockProps={{ size: 'l', sticky: true }}
      style={{ margin: props.margin }}
    >
      <SectionHeadingContent {...props} />
    </IntlErrorBoundary>
  );
};

export default SectionHeading;
